import Api from '../global/api';  
const customerReducer = (state = {
    status: 'LOADING',
    msg: '',
    data: []
}, action) => {
    let current_data = JSON.parse(JSON.stringify(state.data));
    const status = typeof action.status !== 'undefined' ? action.status.toUpperCase(): null;
    const idx = status === 'OK' ? current_data.findIndex(c => c.id_customer === action.payload.id_customer) : -1;

    switch(action.type){
        case "CUSTOMERS_LOAD":
            state = {
                ...state,
                status: status,
                msg: status === 'ERROR'?action.payload:'',
                data: status === 'OK'?action.payload:current_data
            }
            break;
        case "CUSTOMER_ADD":
            if(status === 'OK' && idx > -1)
                current_data[idx] = action.payload;
            else
                current_data.push(action.payload);

            state = {
                ...state,
                status: status,
                msg: status === 'ERROR'?action.payload:'',
                data: current_data
            }
            break;
        case "CUSTOMER_UPDATE":

            if(status === 'OK' && idx > -1)
                if(action.payload.deleted_date === null)
                    current_data[idx] = action.payload;
                else
                    current_data.splice(idx, 1);
            else
                if(action.payload.deleted_data === null)
                    current_data.push(action.payload);
                
            state = {
                ...state,
                status: status,
                msg: status === 'ERROR'?action.payload:'',
                data: current_data
            }
            Api.setLocal('customers', current_data);
            break;
        case "CUSTOMER_UPDATE_BALANCE":
            if(status === 'OK' && idx > -1)
                current_data[idx].balance = action.payload.customer_balance;
                
            state = {
                ...state,
                status: status,
                msg: status === 'ERROR'?action.payload:'',
                data: current_data
            }
            Api.setLocal('customers', current_data);
            break;
        default:
    }
    return state;
}

export default customerReducer;